<template>
  <div class="edit-password-change-component">
    <div v-if="!changePassword" class="request-pass-change">
      <p class="password-validation-info">
        A strong password helps prevent unauthorized access to your onDemand
        account. The requirements are as follows:
      </p>
      <ul class="password-validation-info-list col-xs-6">
        <li>
          <span class="password-validation-text">Minimum of 11 characters</span>
        </li>
        <li>
          <span class="password-validation-text">One uppercase letter</span>
        </li>
        <li>
          <span class="password-validation-text">One lowercase letter</span>
        </li>
        <li>
          <span class="password-validation-text">One number</span>
        </li>
        <li>
          <span class="password-validation-text">One special character</span>
        </li>
        <li>
          <span class="password-validation-text">
            Cannot be same as last three passwords
          </span>
        </li>
      </ul>

      <div class="double-buttons-center edit-password-buttons">
        <a @click="changePasswordClick()" class="button-green vue-anchor">
          CHANGE PASSWORD
        </a>
        <a
          v-show="showReminderButton"
          @click="remindMeLaterClick()"
          class="button-grey vue-anchor"
        >
          REMIND ME LATER
        </a>
      </div>
    </div>

    <PasswordComponent
      v-show="changePassword"
      :show_current_password_field="true"
      :show_cancel_button="false"
      :user_email="this.user.email"
      redirect="/dashboard"
    />
  </div>
</template>

<script>
  import PasswordComponent from '~/components/user/PasswordComponent.vue';

  export default {
    props: {
      user: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        changePassword: false,
        showReminder: true,
      };
    },
    components: {
      PasswordComponent,
    },
    computed: {
      showReminderButton() {
        if (this.user.remind_me_later_skips >= 2) {
          return false;
        }

        return true;
      },
    },
    methods: {
      changePasswordClick: function () {
        this.changePassword = true;
      },
      remindMeLaterClick: function () {
        axios
          .post('/password/update/later', {
            email: this.user.email,
          })
          .then((response) => {
            if (response.data.valid) {
              this.redirectUser();
            }
          })
          .catch(function (error) {
            // TODO: HANDLE ERROR - This is just silencing the error
          });
      },
      redirectUser: function () {
        window.location = '/dashboard';
      },
    },
  };
</script>
